import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_app')({ component: AppLayout });

function AppLayout() {
  return (
    <div className="min-h-screen bg-[hsl(var(--background))]">
      <main>
        <Outlet />
      </main>
    </div>
  );
}
